import * as Const from '../constants';
import State from '../interfaces/state/RegisterFromInviteState';

const initState: State = {
  isLoading: false,
  isError: false,
  isSuccess: false,
};

export default function registerFromInvite(state: State = initState, action: any): State {
  switch (action.type) {
    case Const.REG_FROM_INVITE_INIT:
    case Const.INIT_ALL_APP:
      return {
        ...initState,
      };

    case Const.REG_FROM_INVITE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
      };

    case Const.REG_FROM_INVITE_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.REG_FROM_INVITE_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.REG_FROM_INVITE_SUCCESS_VALUE:
      return {
        ...state,
        isSuccess: action.isSuccess,
      };

    default:
      return state;
  }
}
